import gmailIconUrl from "../../assets/import-icons/gmail-icon.svg";
import googleDocsIconUrl from "../../assets/icons/brands/google-docs.svg";
import googleSheetsIconUrl from "../../assets/icons/brands/google-sheets.svg";
import notionIconUrl from "../../assets/import-icons/notion.png";
import slackIconUrl from "../../assets/icons/brands/slack.svg";
import todoistIconUrl from "../../assets/icons/brands/todoist.svg";

export type ComposioToolkit =
  | "gmail"
  | "googledocs"
  | "googlesheets"
  | "notion"
  | "slack"
  | "todoist";

export interface FeaturedComposioConnection {
  title: string;
  description: string;
  iconUrl: string;
  providerAppIdPrefix: ComposioToolkit;
}

export const FEATURED_COMPOSIO_CONNECTIONS: FeaturedComposioConnection[] = [
  {
    title: "Gmail",
    description: "Sync tasks and projects from your email",
    iconUrl: gmailIconUrl,
    providerAppIdPrefix: "gmail",
  },
  {
    title: "Google Sheets",
    description: "Keep plans and trackers from your spreadsheets in sync",
    iconUrl: googleSheetsIconUrl,
    providerAppIdPrefix: "googlesheets",
  },
  {
    title: "Slack",
    description: "Stay on top of tasks and projects shared in Slack",
    iconUrl: slackIconUrl,
    providerAppIdPrefix: "slack",
  },
  {
    title: "Google Docs",
    description: "Stay on top of tasks and projects in your docs",
    iconUrl: googleDocsIconUrl,
    providerAppIdPrefix: "googledocs",
  },
  {
    title: "Notion",
    description: "Stay on top of tasks and projects in Notion",
    iconUrl: notionIconUrl,
    providerAppIdPrefix: "notion",
  },
  {
    title: "Todoist",
    description: "Review recent task activity from Todoist",
    iconUrl: todoistIconUrl,
    providerAppIdPrefix: "todoist",
  },
];

export function getComposioConnectionApp(toolkit: ComposioToolkit) {
  return FEATURED_COMPOSIO_CONNECTIONS.find(app => app.providerAppIdPrefix === toolkit);
}
